export const expanseSelector = (state) => state.navReducer.collapsed;
export const collapseSelector = (state) => state.navReducer.collapsed;
export const highlightSelector = (state) => state.navReducer.hightlight;
